'use client';
import { Button, Drawer, Image, VStack } from '@skin-seoul/design-system';

interface CartEmptyViewProps {
  onClickContinueShopping: () => void;
}

export const CartEmptyView = ({ onClickContinueShopping }: CartEmptyViewProps) => {
  return (
    <>
      <Drawer.Body
        position="relative"
        padding="0"
        display="flex"
        overflowX="auto"
        paddingX="8px"
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <VStack alignItems="center" justifyContent="center" gap={3}>
          <Image
            src="https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/empty-cart.svg"
            alt="empty cart"
            width={200}
            height={200}
          />

          <Button
            onClick={onClickContinueShopping}
            backgroundColor="neutral.900"
            borderRadius="8px"
            size="lg"
            textTransform="uppercase"
            width="100%"
          >
            Continue Shopping
          </Button>
        </VStack>
      </Drawer.Body>
    </>
  );
};
